import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SealidsReducer(state = initialState.selectedBudgetrefs, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_BUDGETREFS_SUCCESS:
      return action.selectedBudgetrefs;
    default:
      return state;
  }
}
